import i18n from '@/i18n'

export const charRule = {
  validator: (rule, value, callback) => {
    if (value && /[\\/:*?"<|'&%>]/.test(value)) {
      callback(new Error(i18n.t('common.char_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}

export const telRule = {
  validator: (rule, value, callback) => {
    let _value = value.replace(/-/g, '')
    if (_value && !/^[1-9]\d*$/.test(_value)) {
      callback(new Error(i18n.t('common.tel_num_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}

export const min8Max20ChartRule = {
  validator: (rule, value, callback) => {
    if ((value && value.length > 20) || (value && value.length < 8)) {
      callback(new Error(i18n.t('common.new_pwd_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const URLRegExp = {
  validator: (rule, value, callback) => {
    if (value && /(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
      callback()
    } else {
      callback(new Error(i18n.t('common.website_error')))
    }
  }
}
export const allSpaceRule = {
  validator: (rule, value, callback) => {
    if (value.length > 0 && value.trim() === '') {
      callback(new Error(i18n.t('common.all_space_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max16ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 16) {
      callback(new Error(i18n.t('common.max_16_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max32ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 32) {
      callback(new Error(i18n.t('common.max_32_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max64ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 64) {
      callback(new Error(i18n.t('common.max_64_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max128ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 128) {
      callback(new Error(i18n.t('common.max_128_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max255ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 255) {
      callback(new Error(i18n.t('common.max_255_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max2048ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 2048) {
      callback(new Error(i18n.t('common.string_len_2048')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const max256ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 256) {
      callback(new Error(i18n.t('common.max_256_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}

export const max512ChartRule = {
  validator: (rule, value, callback) => {
    if (value && value.length > 512) {
      callback(new Error(i18n.t('common.max_512_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const noAllSpace = {
  validator: (rule, value, callback) => {
    if (value && !/^(?!(\s+$))/.test(value)) {
      callback(new Error(i18n.t('common.all_space_valid_error')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const noChinese = {
  validator: (rule, value, callback) => {
    if (value && /[\u4E00-\u9FA5\uF900-\uFA2D]/.test(value)) {
      callback(new Error(i18n.t('common.no_chinese')))
    } else {
      callback()
    }
  },
  trigger: 'blur'
}
export const requireImgRule = {
  required: true,
  validator: (rule, value, callback) => {
    if (!value) {
      callback(new Error(i18n.t('common.upload_pic')))
    } else {
      callback()
    }
  },
  trigger: 'change'
}
export const requireRule = {
  required: true,
  message: i18n.t('common.require_valid_error'),
  trigger: 'blur'
}

export const requireNumberRule = {
  required: true,
  message: i18n.t('common.require_valid_error'),
  trigger: 'blur',
  type: 'number'
}
